var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFlagEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V400H600V0H0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400L0 0ZM600 0L0 400L600 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.917 200L-16.6406 24.9615L16.6414 -24.9615L300 163.945L583.359 -24.9615L616.641 24.9615L354.084 200L616.641 375.038L583.359 424.961L300 236.055L16.6414 424.961L-16.6406 375.038L245.917 200Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400L0 0ZM600 0L0 400L600 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.945 200L-11.0938 16.641L11.0943 -16.641L300 175.963L588.906 -16.641L611.094 16.641L336.056 200L611.094 383.359L588.906 416.641L300 224.037L11.0943 416.641L-11.0938 383.359L263.945 200Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 0V400V0ZM0 200H600H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350 250V400H250V250H0V150H250V0H350V150H600V250H350Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 0V400V0ZM0 200H600H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330 230V400H270V230H0V170H270V0H330V170H600V230H330Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlagEn);
export default __webpack_public_path__ + "static/media/ic_flag_en.25e1717939c463ed3103d69f92fbb04d.svg";
export { ForwardRef as ReactComponent };